export const ID_FOR_UNSAVED_DATABASE_MODEL = -1;
export const ID_FOR_NEW_DATABASE_MODEL = 0;
export const UNKNOWN_INDEX = -1;

export const HEAVY_FONT = 'small-caps bold 38px sans-serif';
export const LIGHT_FONT = '25px sans-serif';

export const NULL_LENGTH = 0;

// For Observable pipes
export const FIRST_OF_OBSERVABLE = 1;

export const DISPLAY_ORIGIN = { x: 0, y: 0 };

export const FIRST_INDEX = 0;
